<template>
  <div>
    <!-- Pagination here -->
    <div v-if="results.links.first && results.links.last && (results.links.prev || results.links.next)" class="pagination">
      <div class="flex-grow-1">
        Pagina {{ results.meta.current_page }} van {{ results.meta.last_page }}
      </div>
      <nav>
        <ul>
          <li class="page-item page-item-first" v-bind:class="[results.meta.current_page != 1 ? '' : 'disabled']">
            <a class="page-link btn" @click="paginationFirst">
              <i class="material-icons-round">first_page</i>
            </a>
          </li>
          <li class="page-item" v-bind:class="[results.links.prev ? '' : 'disabled']">
            <a class="page-link btn" @click="paginationPrev">
              <i class="material-icons-round">chevron_left</i>
            </a>
          </li>
          <li class="page-item" v-bind:class="[results.links.next ? '' : 'disabled']">
            <a class="page-link btn" @click="paginationNext">
              <i class="material-icons-round">chevron_right</i>
            </a>
          </li>
          <li class="page-item page-item-last" v-bind:class="[results.meta.current_page != results.meta.last_page ? '' : 'disabled']">
            <a class="page-link btn" @click="paginationLast">
              <i class="material-icons-round">last_page</i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    results: Object,
    api: String
  },
  methods: {
    paginationFirst() {
      let params = new URL(this.results.links.first).searchParams;
      this.updateList(params);
    },
    paginationPrev() {
      let params = new URL(this.results.links.prev).searchParams;
      this.updateList(params);
    },
    paginationNext() {
      let params = new URL(this.results.links.next).searchParams;
      this.updateList(params);
    },
    paginationLast() {
      let params = new URL(this.results.links.last).searchParams;
      this.updateList(params);
    },
    async updateList(target) {
      //   modify function to avoid error messages in parent component -jimbo
      //   this.results = await this.getListwithPages(this.api + "?" + target);
      if(this.api.indexOf('?') > 0)
      {
        this.$emit("page-change", this.api + "&" + target);
      }
      else
        this.$emit("page-change", this.api + "?" + target);
    }
  }
};

</script>
<style scoped>

.pagination {
  font-size: 12px;
  color: #64513d;
  align-items: center;
}

.pagination ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.pagination ul li:not(:last-child) {
  margin-right: 15px;
}

.pagination a,
.pagination a {
  height: 45px;
  width: 45px;
  border: 2px solid #f6f6f6;
  border-radius: 10px !important;
}

.pagination .page-item-first a,
.pagination .page-item-last a {
  height: 25px;
  width: 25px;
}

.pagination a i,
.pagination a i {
  display: block;
  line-height: 45px;
  color: #64513d;
}

.pagination .page-item-first a i,
.pagination .page-item-last a i {
  line-height: 25px;
  font-size: 18px;
}

</style>